import { ReactElement } from 'react'
import { StreamStep } from 'src/v3/core/types'
import { VideoIcon, EditIcon, QuizIcon, ShowNotesIcon } from 'src/v3/core/icons'

export type StepType = 'video' | 'showNotes' | 'quiz' | 'unknown'

export function getStepType(step: StreamStep): StepType {
  if (step.videoID) return 'video'
  if (step.showNotesID) return 'showNotes'
  if (step.quizID) return 'quiz'
  return 'unknown'
}

export function getStepIcon(stepType: StepType): ReactElement {
  if (stepType === 'video') return <VideoIcon />
  if (stepType === 'showNotes') return <ShowNotesIcon />
  if (stepType === 'quiz') return <QuizIcon />
  return <EditIcon />
}

export function getStepChipColor(
  stepType: StepType,
): 'primary' | 'success' | 'secondary' {
  let colors = {
    video: 'primary' as const,
    showNotes: 'success' as const,
    quiz: 'secondary' as const,
    unknown: 'success' as const,
  }
  return colors[stepType]
}

export function getStepLabel(stepType: StepType): string {
  let labels = {
    video: 'Video',
    showNotes: 'Show Notes',
    quiz: 'Quiz',
    unknown: 'Unknown',
  }
  return labels[stepType]
}

export function getStepIconColor(stepType: StepType): string {
  let colors = {
    video: 'primary.main',
    showNotes: 'success.main',
    quiz: 'secondary.main',
    unknown: 'text.secondary',
  }
  return colors[stepType]
}
